import store from '../store'

export default [
  {
    path: '/industrias/:key/telefone',
    name: 'industrias-create-telefone',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.commit('setTelefone', {})
      await store.dispatch('getIndustria', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Novo telefone da industria',
      documentAttrTelefone: 'industria',
      titleAttr: 'nome_fantasia',
      actionSaveTelefone: 'postSaveTelefoneNaIndustria',
      titleAlertRemoveTelefone: 'Confirme a exclusão deste telefone da industria.',
      routeToBack: 'industrias-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/telefone')
    }
  },
  {
    path: '/industrias/:key/telefone/:id',
    name: 'industrias-update-telefone',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getTelefoneDaIndustria', {
        id: Number(to.params.id)
      })
      await store.dispatch('getIndustria', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Editar telefone da industria',
      documentAttrTelefone: 'industria',
      titleAttr: 'nome_fantasia',
      actionSaveTelefone: 'postSaveTelefoneNaIndustria',
      titleAlertRemoveTelefone: 'Confirme a exclusão deste telefone da industria.',
      routeToBack: 'industrias-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/telefone')
    }
  },
  {
    path: '/clientes/:key/telefone',
    name: 'clientes-create-telefone',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.commit('setTelefone', {})
      await store.dispatch('getCliente', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Novo telefone do cliente',
      documentAttrTelefone: 'cliente',
      titleAttr: 'nome',
      actionSaveTelefone: 'postSaveTelefoneNoCliente',
      titleAlertRemoveTelefone: 'Confirme a exclusão deste telefone do cliente.',
      routeToBack: 'clientes-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/telefone')
    }
  },
  {
    path: '/clientes/:key/telefone/:id',
    name: 'clientes-update-telefone',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getTelefoneDoCliente', {
        id: Number(to.params.id)
      })
      await store.dispatch('getCliente', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Editar telefone do cliente',
      documentAttrTelefone: 'cliente',
      titleAttr: 'nome',
      actionSaveTelefone: 'postSaveTelefoneNoCliente',
      titleAlertRemoveTelefone: 'Confirme a exclusão deste telefone do cliente.',
      routeToBack: 'clientes-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/telefone')
    }
  },
  {
    path: '/responsaveis/:key/telefone',
    name: 'responsaveis-create-telefone',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.commit('setTelefone', {})
      await store.dispatch('getResponsavelDoCliente', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Novo telefone do responsável',
      documentAttrTelefone: 'responsavelDoCliente',
      titleAttr: 'nome',
      actionSaveTelefone: 'postSaveTelefoneDoResponsavel',
      titleAlertRemoveTelefone: 'Confirme a exclusão deste telefone do responsável.',
      routeToBack: 'clientes-responsaveis-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/telefone')
    }
  },
  {
    path: '/responsaveis/:key/telefone/:id',
    name: 'responsaveis-update-telefone',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getTelefoneDoResponsavel', {
        id: Number(to.params.id)
      })
      await store.dispatch('getResponsavelDoCliente', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Editar telefone do responsável',
      documentAttrTelefone: 'responsavelDoCliente',
      titleAttr: 'nome',
      actionSaveTelefone: 'postSaveTelefoneDoResponsavel',
      titleAlertRemoveTelefone: 'Confirme a exclusão deste telefone do responsável.',
      routeToBack: 'clientes-responsaveis-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/telefone')
    }
  },
  {
    path: '/tecnicos/:key/telefone',
    name: 'tecnicos-create-telefone',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.commit('setTelefone', {})
      await store.dispatch('getTecnico', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Novo telefone do técnico',
      documentAttrTelefone: 'tecnico',
      titleAttr: 'nome',
      actionSaveTelefone: 'postSaveTelefoneDoTecnico',
      titleAlertRemoveTelefone: 'Confirme a exclusão deste telefone do técnico.',
      routeToBack: 'tecnicos-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/telefone')
    }
  },
  {
    path: '/tecnicos/:key/telefone/:id',
    name: 'tecnicos-update-telefone',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getTelefoneDoTecnico', {
        id: Number(to.params.id)
      })
      await store.dispatch('getTecnico', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Editar telefone do técnico',
      documentAttrTelefone: 'tecnico',
      titleAttr: 'nome',
      actionSaveTelefone: 'postSaveTelefoneDoTecnico',
      titleAlertRemoveTelefone: 'Confirme a exclusão deste telefone do técnico.',
      routeToBack: 'tecnicos-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/telefone')
    }
  }
]
